import React from "react"

export default function DeliveryAddressForm(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { state, setState, errors, venue, isTakeAway = false } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleInputChange(event) {
    const target = event.target
    const value = target.type === "checkbox" ? target.checked : target.value
    const name = target.name

    setState({ ...state, [name]: value })
  }

  function showErrorsFor(name) {
    const _errors = errors[name] || []

    return _errors.map((error, index) => {
      return (
        <div key={index} className="help-block error">
          {error}
        </div>
      )
    })
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const venueAddress =
    venue && `${venue.street_name}, ${venue.street_number}, ${venue.city}`

  // -------------------------------------

  return (
    <div className="delivery-address-form order-step">
      {!isTakeAway ? (
        <div>
          <h4 className="separated-bottom">
            {I18n.t("cart_summary.deliver_to_address")}
          </h4>
          <fieldset>
            <div className="row separated">
              <div className="col-sm-8 col-xs-8">
                <div className="form-group">
                  <label htmlFor="street_name" className="control-label">
                    {I18n.t("cart_summary.street_name")} *
                  </label>
                  <input
                    disabled={state.street_name} // TODO: use readonly
                    type="text"
                    name="street_name"
                    className="form-control"
                    value={state.street_name}
                    onChange={handleInputChange}
                  />
                  {showErrorsFor("street_name")}
                </div>
              </div>

              <div className="col-sm-4 col-xs-4">
                <div className="form-group">
                  <label htmlFor="street_number" className="control-label">
                    {I18n.t("cart_summary.street_number")} *
                  </label>
                  <input
                    disabled={state.street_number} // TODO: use readonly
                    type="text"
                    name="street_number"
                    className="form-control"
                    value={state.street_number}
                    onChange={handleInputChange}
                  />
                  {showErrorsFor("street_number")}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-8 col-xs-8">
                <div className="form-group">
                  <label htmlFor="city" className="control-label">
                    {I18n.t("cart_summary.city")} *
                  </label>
                  <input
                    type="text"
                    name="city"
                    readOnly
                    className="form-control"
                    value={state.city}
                  />
                  {showErrorsFor("city")}
                </div>
              </div>
              <div className="col-sm-4 col-xs-4">
                <div className="form-group">
                  <label htmlFor="postal_code" className="control-label">
                    {I18n.t("cart_summary.postal_code")} *
                  </label>
                  <input
                    disabled={state.postal_code} // TODO: use readonly
                    type="text"
                    name="postal_code"
                    className="form-control"
                    value={state.postal_code}
                    onChange={handleInputChange}
                  />
                  {showErrorsFor("postal_code")}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <label htmlFor="delivery_notes" className="control-label">
                    {I18n.t("cart_summary.delivery_notes")}
                  </label>
                  <textarea
                    name="delivery_notes"
                    placeholder={I18n.t(
                      "cart_summary.delivery_notes_placeholder"
                    )}
                    className="form-control"
                    value={state.delivery_notes}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="form-group">
                  <span className="checkbox">
                    <label className="control-label">
                      <input
                        type="checkbox"
                        name="restricted_traffic_area"
                        checked={state.restricted_traffic_area}
                        onChange={handleInputChange}
                      />
                      {I18n.t("cart_summary.restricted_traffic_area")}
                    </label>
                  </span>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      ) : (
        <div className="takeawy-message py-5">
          <h4>
            {I18n.t("cart_summary.pickup_title")} <strong>{venue.name}</strong>{" "}
            ({venueAddress})
          </h4>
        </div>
      )}
    </div>
  )
}
